import React, { useState } from 'react';
import './pricingCards.css';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { FiCheck } from 'react-icons/fi';
import { apiFetch } from '../../api/client';

const TIERS = [
  {
    id: 'free',
    name: 'Free',
    price: '$0',
    period: 'forever',
    features: [
      '2 resume generations per day',
      '1 LaTeX template',
      'Full editor with live PDF preview',
      'Unlimited PDF downloads'
    ],
    cta: 'Get started'
  },
  {
    id: 'plus',
    name: 'Plus',
    price: '$3.99',
    period: 'per month',
    highlight: true,
    features: [
      '25 resume generations per day',
      'Save up to 50 resumes',
      '4 LaTeX templates',
      'Full editor with live PDF preview',
      'Unlimited PDF downloads'
    ],
    cta: 'Upgrade to Plus'
  },
  {
    id: 'pro',
    name: 'Pro',
    price: '$8.99',
    period: 'per month',
    features: [
      '75 resume generations per day',
      'Save up to 150 resumes',
      'All LaTeX templates',
      'AI prompt editing — 10 edits per day',
      'Full editor with live PDF preview',
      'Unlimited PDF downloads'
    ],
    cta: 'Upgrade to Pro'
  }
];

function PricingCards() {
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const [note, setNote] = useState(null);
  const [loadingTier, setLoadingTier] = useState(null);

  const handleSelect = async (tier) => {
    if (!user) {
      navigate('/register');
      return;
    }
    if (tier.id === 'free') {
      navigate('/app/resume');
      return;
    }
    setLoadingTier(tier.id);
    setNote(null);
    try {
      const data = await apiFetch('/api/billing/checkout-session', {
        method: 'POST',
        body: { tier: tier.id }
      });
      window.location.assign(data.url);
    } catch (e) {
      setNote(e.message || 'Could not start checkout');
      setLoadingTier(null);
    }
  };

  return (
    <div className="pricingCardsWrap">
      <div className="pricingGrid">
        {TIERS.map((tier) => (
          <div key={tier.id} className={`pricingCard ${tier.highlight ? 'highlight' : ''}`}>
            {tier.highlight && <span className="popularPill">Most popular</span>}
            <h3 className="pricingTierName">{tier.name}</h3>
            <div className="pricingPriceRow">
              <span className="pricingPrice">{tier.price}</span>
              <span className="pricingPeriod">/ {tier.period}</span>
            </div>
            <ul className="pricingFeatures">
              {tier.features.map((f) => (
                <li key={f}><FiCheck size={14} /> {f}</li>
              ))}
            </ul>
            <button
              className={`pricingCta ${tier.highlight ? 'solid' : 'ghost'}`}
              onClick={() => handleSelect(tier)}
              disabled={loadingTier !== null}
            >
              {loadingTier === tier.id ? 'Redirecting…' : tier.cta}
            </button>
          </div>
        ))}
      </div>
      {note && <p className="pricingNote">{note}</p>}
    </div>
  );
}

export default PricingCards;
